import { Plugin, PluginKey } from 'prosemirror-state';
import BulletList from '@tiptap/extension-bullet-list'
import { Extension, markPasteRule, mergeAttributes, InputRule } from '@tiptap/core'
import {
    TextSelection,
} from '@tiptap/pm/state';
import { joinForward } from 'prosemirror-commands';
export const getBubblletListExtend = ()=>{
    return BulletList.extend({
        addAttributes() {
            return {
                ...this.parent?.(), // 保留原有的属性
                blockHighlight: {
                    default: false,
                },
                noteText: {
                    default: ''
                },
                ifhidden: {
                    default: false,
                    renderHTML: attributes => {
                        if (attributes.ifhidden === undefined) {
                            return {};
                        }
                        return {
                            'ifhidden': attributes.ifhidden,
                        };
                    },
                },
            };
        },
        addProseMirrorPlugins() {
            return [
                new Plugin({
                    key: new PluginKey("detectIndentBeforeList"),
                    props: {
                        handleKeyDown: (view, event) => {
                            if (event.key === "Enter") {
                                setTimeout(() => {
                                    const { state } = view;
                                    const { selection } = state;
                                    const { from } = selection;
                                    const resolvedPos = this.editor.state.doc.resolve(from);
                                    // 获取当前节点
                                    const currentNode = resolvedPos.node();

                                    // 获取当前节点的起始位置
                                    const nodeStart = resolvedPos.start(resolvedPos.depth);

                                    // 检查前面是否有 Indent
                                    if (currentNode.type.name === "paragraph" && currentNode.attrs.indent > 0) {
                                        const transaction = state.tr.setNodeMarkup(nodeStart - 1, undefined, {
                                            ...currentNode.attrs,
                                            indent: 0,
                                        });
                                        view.dispatch(transaction);
                                    }
                                }, 10);
                            }
                            return false;
                        },
                    },
                }),
            ];
        },
        addInputRules() {
            return [
                // bulletlist 关键字
                new InputRule({
                    find: /^\s*-\s$/,
                    handler: ({ state, range, match, chain }) => {
                        // 针对先tab缩进，然后快捷生成嵌套list的行为： 需要拦截默认生成的行为并进行list结构替换
                        // 针对先tab缩进，然后快捷生成嵌套list的行为： 需要拦截默认生成的行为并进行list结构替换
                        const resolvedPos = this.editor.state.doc.resolve(range.from);
                        const nodeStart = resolvedPos.start(resolvedPos.depth);
                        const nodeEnd = resolvedPos.end(resolvedPos.depth);

                        // 获取当前节点及其父节点
                        const currentNode = resolvedPos.node();
                        const parentNode = resolvedPos.node(resolvedPos.depth - 1);
                        // 获取上一个相邻节点
                        let lastNodeResolved;
                        let nextNodeResolved;
                        try {
                            lastNodeResolved = this.editor.state.doc.resolve(nodeStart - 2);
                        } catch (error) {
                            lastNodeResolved = undefined
                        }
                        try {
                            nextNodeResolved = this.editor.state.doc.resolve(nodeEnd + 2);
                        } catch (error) {
                            nextNodeResolved = undefined
                        }
                        const lastNode = lastNodeResolved?.node();
                        const nextNode = nextNodeResolved?.node();
                        // 合并两个list
                        if (lastNode?.type.name === 'bulletList' && nextNode?.type.name === 'bulletList') {
                            setTimeout(() => {
                                this.editor.chain().focus().command(({ state, dispatch }) => {
                                    return joinForward(state, dispatch);
                                }).run();
                            }, 50);
                        }

                        const { schema } = state;
                        const tr = state.tr;
                        if (currentNode.type.name === 'paragraph' && currentNode.attrs.indent >= 1 && lastNodeResolved && lastNode?.type.name && ['bulletList', 'orderedList', 'taskList'].includes(lastNode?.type.name)) {
                            // list结构替换: 在原先结构的最后一级item后加上二级item
                            let lastNodeJson = lastNode.toJSON();
                            const uuid = crypto.randomUUID()
                            const listItem = schema.nodes.listItem.create({}, schema.nodes.paragraph.create({ id: uuid }));
                            const bulletList = schema.nodes.bulletList.create({}, [listItem]);
                            const lastNodeStart = lastNodeResolved.start(lastNodeResolved.depth);
                            let firstLevelLastListItem = lastNodeJson.content[lastNodeJson.content.length - 1]

                            firstLevelLastListItem.content.push(bulletList.toJSON())
                            lastNodeJson.content[lastNodeJson.content.length - 1] = firstLevelLastListItem
                            tr.replaceRangeWith(lastNodeStart, nodeEnd, this.editor.schema.nodeFromJSON(lastNodeJson));
                            this.editor.view.dom.blur();
                            this.editor.view.dispatch(tr);
                            setTimeout(() => {
                                const selectNodeNP = this.editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
                                this.editor.commands.focus(selectNodeNP.from)
                            }, 10);
                            return true;
                        }
                        return false;
                    }
                }),
                // orderlist 关键字
                new InputRule({
                    find: /^\s*\d+\.\s$/,
                    handler: ({ state, range, match, chain }) => {
                        // 针对先tab缩进，然后快捷生成嵌套list的行为： 需要拦截默认生成的行为并进行list结构替换
                        const resolvedPos = this.editor.state.doc.resolve(range.from);
                        const nodeStart = resolvedPos.start(resolvedPos.depth);
                        const nodeEnd = resolvedPos.end(resolvedPos.depth);

                        // 获取当前节点及其父节点
                        const currentNode = resolvedPos.node();
                        const parentNode = resolvedPos.node(resolvedPos.depth - 1);
                        // 获取上一个相邻节点
                        let lastNodeResolved;
                        let nextNodeResolved;
                        try {
                            lastNodeResolved = this.editor.state.doc.resolve(nodeStart - 2);
                        } catch (error) {
                            lastNodeResolved = undefined
                        }
                        try {
                            nextNodeResolved = this.editor.state.doc.resolve(nodeEnd + 2);
                        } catch (error) {
                            nextNodeResolved = undefined
                        }
                        const lastNode = lastNodeResolved?.node();
                        const nextNode = nextNodeResolved?.node();
                        // 合并两个list
                        if (lastNode?.type.name === 'orderedList' && nextNode?.type.name === 'orderedList') {
                            setTimeout(() => {
                                this.editor.chain().focus().command(({ state, dispatch }) => {
                                    return joinForward(state, dispatch);
                                }).run();
                            }, 50);
                        }

                        const { schema } = state;
                        const tr = state.tr;
                        if (currentNode.type.name === 'paragraph' && currentNode.attrs.indent >= 1 && lastNodeResolved && lastNode?.type.name && ['bulletList', 'orderedList', 'taskList'].includes(lastNode?.type.name)) {
                            // list结构替换: 在原先结构的最后一级item后加上二级item
                            let lastNodeJson = lastNode.toJSON();
                            const uuid = crypto.randomUUID()

                            const listItem = schema.nodes.listItem.create({}, schema.nodes.paragraph.create({ id: uuid }));
                            const orderedList = schema.nodes.orderedList.create({}, [listItem]);
                            const lastNodeStart = lastNodeResolved.start(lastNodeResolved.depth);
                            let firstLevelLastListItem = lastNodeJson.content[lastNodeJson.content.length - 1]

                            firstLevelLastListItem.content.push(orderedList.toJSON())
                            lastNodeJson.content[lastNodeJson.content.length - 1] = firstLevelLastListItem
                            tr.replaceRangeWith(lastNodeStart, nodeEnd, this.editor.schema.nodeFromJSON(lastNodeJson));
                            this.editor.view.dom.blur();
                            this.editor.view.dispatch(tr);
                            setTimeout(() => {
                                const selectNodeNP = this.editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
                                this.editor.commands.focus(selectNodeNP.from)
                            }, 10);
                            return true;
                        }
                        return false;
                    }
                }),
            ];
        },
    })
}